<template>
    <!-- Variante « pastille » (en-tête de l'app) : état de la connexion en clair -->
    <span v-if="pill" class="net-pill" :class="'lvl' + getWifiLvl" :title="pillTitle">
        <i></i><span class="net-pill-txt">{{ pillLabel }}</span>
    </span>
    <div v-else style="" class="">
        <div align=center style=" background-color: white;border-radius: 100%;width: 30px;   border: solid 2px;" :style="{'border-color': speedLvl[getWifiLvl].color}">
            <v-icon :color="speedLvl[getWifiLvl].color" size="15" class="" >
                mdi-wifi-arrow-left-right
            </v-icon>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            speed: null,
            speedLvl: {
                0: {
                    color: 'red'
                },
                1: {
                    color: 'orange'
                },
                2: {
                    color: 'green'
                },
            },

        }
    },
    props : {
        getLvl:{type:Function},
        pill:{type:Boolean, default:false}
    },
    watch : {
        getWifiLvl(val){
            if (this.getLvl) this.getLvl(val)
        }
    },
    mounted() {
        this.updateNetworkSpeed();
    },
    computed: {
        pillLabel() {
            if (typeof navigator !== "undefined" && navigator.onLine === false) return "Hors ligne"
            return ["Connexion faible", "Connexion lente", "En ligne"][this.getWifiLvl]
        },
        pillTitle() {
            return "État de la connexion (vérifié toutes les 30 s) : " + this.pillLabel.toLowerCase()
        },
        getWifiLvl() {
            if (this.speed > 1) {
                return 2
            }
            if (this.speed > 0.3) {
                return 1
            }
            return 0
        },
    },
    methods: {
        updateNetworkSpeed() {
            this.measureNetworkSpeed();
            setInterval(() => {
                this.measureNetworkSpeed();
            }, 30000); // Update every 5 seconds
        },
        
    measureNetworkSpeed() {
      let that = this
      const startTime = performance.now();

      fetch('https://' + process.env.VUE_APP_MAIN_URL) // URL of the website you want to measure
        .then(response => {
          const endTime = performance.now();
          const duration = (endTime - startTime) / 100000; // in seconds
          that.speed = this.calculateSpeed(response.headers, duration)
        })
        .catch(error => {
          console.error('Error measuring network speed:', error);
          that.speed = null;
        });
    },

    calculateSpeed(headers, duration) {
      const contentLength = parseFloat(headers.get('Content-Length'));
      if (!contentLength || isNaN(contentLength)) {
        console.error('Content-Length header not found or invalid.');
        return null;
      }

      const fileSizeBytes = contentLength;
      const fileSizeMb = fileSizeBytes / 1024 / 1024;
      const speedMbps = (fileSizeMb / duration).toFixed(6); // calculate speed in Mbps
      return speedMbps;
    },

    }
}
</script>

<style scoped>
.net-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
}
.net-pill i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.net-pill.lvl2 { background: #e9f7ef; color: #1e7a46; }
.net-pill.lvl2 i { background: #2fb36d; box-shadow: 0 0 0 3px rgba(47, 179, 109, 0.18); }
.net-pill.lvl1 { background: #fff4e5; color: #b45309; }
.net-pill.lvl1 i { background: #f59e0b; }
.net-pill.lvl0 { background: #fdecea; color: #c62828; }
.net-pill.lvl0 i { background: #ef4444; }
/* Mobile : le point seul suffit */
@media (max-width: 600px) {
    .net-pill { padding: 7px; }
    .net-pill-txt { display: none; }
}
</style>